import angular from 'angular';
import template from './diversityFilters.html';
import './style.scss';

const RACE_DIVERSITY_SHORT_LABELS = {
    black: 'BLACK_DIVERSITY_FILTER_VALUE_SHORT',
    hispanic: 'HISPANIC_DIVERSITY_FILTER_VALUE',
    asian: 'ASIAN_DIVERSITY_FILTER_VALUE',
};

export class DiversityToolbar {
    isExpandedRaceDropdown = false;

    /* @ngInject */
    constructor($scope, $filter) {
        this.$scope = $scope;
        this.$filter = $filter;
    }

    $onChanges() {
        this.$scope.searchCtrl = this.searchCtrl;
    }

    setExpandedRaceDropdown(value) {
        this.isExpandedRaceDropdown = value;
    }

    getFirstOptionLabel() {
        const selectedIds = (this.searchCtrl.raceOptions || [])
            .filter(({ isSelected }) => isSelected)
            .map(({ id }) => id);
        const [firstOption] = selectedIds;
        return this.$filter('translate')(RACE_DIVERSITY_SHORT_LABELS[firstOption]);
    }

    selectRace(raceId) {
        this.searchCtrl.onRaceCheck(raceId);
        this.isExpandedRaceDropdown = false;
    }
}

export const DiversityToolbarConfiguration = {
    template,
    bindings: {
        groupName: '@',
    },
    require: {
        searchCtrl: '^searchComponentNew',
    },
    controller: DiversityToolbar,
    controllerAs: 'diversityToolbarCtrl',
};

angular
    .module('TALENYA-FE')
    .component('diversityToolbar', DiversityToolbarConfiguration);
